import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbPopover, NgbPopoverConfig, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, CmsService, OccEndpointsService, RoutingService, StorageSyncType, WindowRef } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { distinctUntilChanged, filter, map, take } from "rxjs/operators";
import { CustomPdpService } from "src/app/custom-pdp/custom-pdp.service";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { CustomProfileAndPreferencesService } from "src/app/custom-profile-and-preferences/custom-profile-and-preferences.service";
import { CheckoutService } from "src/app/shared/modules/checkout/checkout.service";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { SharedService } from "src/app/shared/services/shared.service";
import * as _ from 'underscore';
import { OrderHistoryService } from '../../order-history/order-history.service';
import { CustomAddToCartService } from "../custom-add-to-cart.service";
import { navigateToNewOnboarding } from "src/app/shared/modules/release-banner/constants";
import { getLoginGateReturnUrl } from "src/app/utils/build-login-url";
import { LoginEntryService } from "../../shared/services/login-entry.service";
import { CartEntryService } from "../../shared/services/cart-entry.service";
import { VscaLoginFormComponentService } from '../../spartacus/features/user/account/components/login-form';
import { getStorage, readFromStorage } from '../../utils/browser-storage';
import { CustomAuthService } from '../../custom-auth-service.service';

@Component({
    selector: 'app-mini-cart',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './mini-cart.component.html',
    styleUrls: ['./mini-cart.component.scss'],
    standalone: false
})
export class MiniCartComponent implements OnInit, OnDestroy {
  private readonly loginFormComponentService = inject(VscaLoginFormComponentService);
  private readonly loginEntryService = inject(LoginEntryService);
  private readonly cartEntryService = inject(CartEntryService);
  protected windowRef = inject(WindowRef);
  protected activatedRoute = inject(ActivatedRoute);
  protected storage = getStorage(StorageSyncType.LOCAL_STORAGE, this.windowRef);

  private readonly FLOW_KEY = 'vsca_oauth_flow_ts';
  private readonly DISPLAY_LOGIN_KEY = 'display_login';
  /** Maximum ms to wait for the hybris OAuth redirect before the flag expires. */
  private readonly FLOW_TTL_MS = 60_000;
  name = 'World';
  itemInCart = false;
  userDetails: any;
  isFlu = false;
  currentPage: any;
  standardCartDetails: any;
  influenzaCartDetails: any;
  userAccountgetData: any;
  stdCartEntries: any;
  totalquantityCart: any;
  totalquantityfluCart: any;
  fluCartDetails: any;
  fluCartEntries: any;
  productEntries: any = [];
  searchedClientList: any;
  selectedData: any;
  productFluEntries = [];
  stdCartEntry = 0;
  isEmpty = true;
  allCartDetails: any;
  stdCartDetails: any;
  public images: any;
  totalQuantity: any = [];
  totalQuantityFlu: any = [];
  quantityDisplay: any;
  quantityDisplayFlu: any;
  saveCartName: string;
  usergetDataObj: any;
  getuserData: any;
  baseUrl: string;
  cartId: any;
  isEmptyFlu = false;
  fallbackImage = 'i18n-assets/sanofi_missing_product.jpg';
  errorMsg: string;
  cartSavedSuccess: string;
  cartItems: any;
  @ViewChild('p1') public emptypopover: NgbPopover;
  @ViewChild('popTitleSuccess', { static: false })
  private readonly popTitleSuccess;
  @ViewChild('p2') public stdpopover: NgbPopover;
  @ViewChild('t') public tooltip: NgbTooltip;
  @ViewChild('p4') public flupopover: NgbPopover;
  @ViewChild('s1') public savedpopover: NgbPopover;
  @ViewChild('s3') public saveorderpopover: NgbPopover;
  @ViewChild('c1') public sessionCartPopover: NgbPopover;
  @ViewChild('p5') public successLogoutPopover: NgbPopover;
  updatedStdSub: Subscription;
  plpMiniCartSub: Subscription;
  pdpMiniCartSub: Subscription;
  updateSessionSub: Subscription;
  restoreSub: Subscription;
  saveOrderSub: Subscription;
  orderHistorySub: Subscription;
  allCartItemsSub: Subscription;
  userAccountSub: Subscription;
  userAccountDetailsSub: Subscription;
  cartItemsSub: Subscription;
  invalidCartSub: Subscription;
  saveCartSub: Subscription;
  userAccSub: Subscription;
  authCheck: Subscription;
  orderSubTotal: any;
  isSingleLocation = true;
  baseSiteId: any;
  fluJourneyPage: boolean = false;
  punchOutKey: boolean;
  getUserSub: Subscription;
  userSub: Subscription;
  userIdDetails: any;


  constructor(
    private readonly user: UserAccountFacade,
    private readonly addToCart: CustomAddToCartService,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: RoutingService,
    private readonly pageDate: CmsService,
    private readonly config: NgbPopoverConfig,
    private readonly occEndPoint: OccEndpointsService,
    private readonly plpService: CustomProdPgService,
    private readonly pdpService: CustomPdpService,
    private readonly checkoutService: CheckoutService,
    private readonly orderHistoryService: OrderHistoryService,
    private readonly sharedService: SharedService,
    private readonly modalService: NgbModal,
    private readonly authService: CustomAuthService,
    private readonly locService: LoactionStripService,
    private baseSiteService: BaseSiteService,
    private router: Router,
    private profService: CustomProfileAndPreferencesService
  ) {
    config.autoClose = 'outside';
    config.closeDelay = 2000;
    config.openDelay = 1000;
  }
  tooltipToggle() {
    this.tooltip.open();
  }

  ngOnInit(): void {
     const displayLogin = readFromStorage<boolean>(
      this.storage as Storage,
      this.DISPLAY_LOGIN_KEY
    );

    this.loginFormComponentService.showLoginForm.set(displayLogin !== undefined ? displayLogin : false);

    if (localStorage.getItem('punchout-sid-key') != null) {
      this.punchOutKey = true;
      this.cdr.detectChanges();
    }

    this.authService.logoutInProgress$.subscribe((res) => {
      if (res) {
        this.authCheck = this.authService.isUserLoggedIn().subscribe((res) => {
          if (!res) {

            this.authCheck?.unsubscribe();
            this.successLogoutPopover.open();
            setTimeout(() => this.successLogoutPopover.close(), 2500);
          }
        });
      }
    });
    this.itemInCart = true;
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);

    this.updatedStdSub = this.checkoutService.updatedStdOrderDetails$.subscribe(
      (res) => {
        if (res
          && (this.currentPage !== 'fluCategoryPage' &&
            this.currentPage !== 'fluStsLandingPage' &&
            this.currentPage !== 'FluverifypaymentPage' &&
            this.currentPage !== 'orderConfirmationFluPage' &&
            this.currentPage !== 'fluseasonreservationpage')) {//To avoid making get cart calls without stdcart false during flu journey as asked by Manoj
          this.addToCart.getAllCarts(this.userAccountgetData?.uid);

          this.plpService.getCarts(this.userDetails?.uid);
          this.addToCart.cartItems.next(false);
        }
      }
    );
    this.plpMiniCartSub = this.plpService
      .getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.getCartDetails(res);
        }
      });
    this.pdpMiniCartSub = this.pdpService
      .getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.getCartDetails(res);
        }
      });
    this.updateSessionSub = this.addToCart
      .getUpdateSessionCart()
      .subscribe((res) => {
        if (res) {
          this.getCartDetails(res);
        }
      });
    this.restoreSub = this.addToCart.getRestoredCart().subscribe((res) => {
      if (res) {
        this.getCartDetails(res);

      }
    });
    this.saveOrderSub = this.addToCart
      .getUpdateSavedOrder()
      .subscribe((res) => {
        if (res) {
          this.cartSavedSuccess = res?.savedCartData?.name;
          this.savedpopover.open();
          setTimeout(() => this.savedpopover.close(), 2500);
        }
      });
    this.orderHistorySub = this.orderHistoryService
      .getSavedOrderName()
      .subscribe((res) => {
        if (res) {
          this.cartSavedSuccess = res?.savedCartData?.name;
          this.savedpopover.open();
          setTimeout(() => this.savedpopover.close(), 2500);
        }
      });

    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.pageDate.getCurrentPage().subscribe((res) => {
      this.currentPage = res?.pageId;
      if (res) {
        const sessionCartPopover = res?.slots?.MiniCart;

        const registerKey = sessionStorage.getItem('register');
        if (Object.keys(sessionCartPopover).length === 0 && registerKey == null) {
          sessionStorage.clear();
        }
      }
      if (this.currentPage === 'fluCategoryPage' ||
        this.currentPage === 'fluStsLandingPage' ||
        this.currentPage === 'FluverifypaymentPage' ||
        this.currentPage === 'orderConfirmationFluPage' ||
        this.currentPage === 'fluseasonreservationpage') {
        this.fluJourneyPage = true;
        this.cdr.detectChanges();
      }
      else {
        this.fluJourneyPage = false;
        this.cdr.detectChanges();
      }

      if (
        this.currentPage === 'fluseasonreservationpage' ||
        this.currentPage === 'FluSeasonProductListPage' ||
        this.currentPage === 'fluseasonviewcartpage' ||
        this.currentPage === 'fluseasonviewpaymentpage' ||
        this.currentPage === 'flureservationconfirmationpage' ||
        this.currentPage === 'flureservationoverviewpage'
      ) {
        this.isFlu = true;
      } else {
        this.isFlu = false;
      }
      this.cdr.detectChanges();
    }, errors => {
      this.fluJourneyPage = false;  //in case of any error just keeping default value
    });
    this.userAccSub = this.authService.isUserLoggedIn().pipe(distinctUntilChanged()).subscribe((res) => {


      const miniCart = document.getElementById(`miniCart`) as HTMLElement;
      this.profService._userAccountData.pipe(filter(res => !!res), map(({ defaultB2BUnit }) => ({ uid: defaultB2BUnit.uid })), take(1)).subscribe((res2) => {

        if (res && res2) {


          setTimeout(() => {
            if (
              this.sharedService.miniCartPopup === true &&
              this.allCartDetails &&
              this.allCartDetails?.length > 0
            ) {

              $('#cartNotificationPopup').show();
            } else {

              $('#cartNotificationPopup').hide();
            }
          }, 4000);
          this.userDetails = this.userAccountgetData = { uid: JSON.parse(localStorage.getItem('userId')) };
          $('#loginRegisterButton').css('display', 'none');
          miniCart.classList.remove('not-visible');
          this.cdr.detectChanges();
          this.getUserAccountData(this.userAccountgetData.uid);

          if (this.currentPage !== 'fluCategoryPage' &&
            this.currentPage !== 'fluStsLandingPage' &&
            this.currentPage !== 'FluverifypaymentPage' &&
            this.currentPage !== 'orderConfirmationFluPage' &&
            this.currentPage !== 'fluseasonreservationpage') {
            this.addToCart.getAllCarts(this.userAccountgetData?.uid);
            this.plpService.getCarts(this.userAccountgetData?.uid);
          }
          this.allCartItemsSub = this.addToCart.allCartItems$.subscribe(
            (res1) => {
              if (res1) {
                this.cartItems = res1?.carts;

                this.cartItems = this.cartItems?.filter(
                  (item) => item?.saveTime === undefined
                );
                this.cartItems = !!this.cartItems?.length && this.cartItems[this.cartItems?.length - 1];
                if (this.cartItems === undefined) {
                  $('#cartNotificationPopup').hide();
                  this.isEmpty = true;
                  this.quantityDisplay = '';
                  this.cdr.detectChanges();
                  this.addToCart.cartItems.next(false);
                  this.cdr.detectChanges();
                }
                this.cartId = this.cartItems?.code;
                this.getCartDetails(this.cartId);
              }
            }
          );

        }
      });
      if (!res) {
        $('#loginRegisterButton').css('display', 'flex');
        miniCart.classList.add('not-visible');
        $('#cartNotificationPopup').hide();
        sessionStorage.removeItem('sessionCartPopover');
        this.addToCart.deleteCartCache();
        this.allCartItemsSub?.unsubscribe();
      }
      this.cdr.detectChanges();
    });



    this.locService.emitSelectedLocs.subscribe((res) => {
      if (res) {
        this.isSingleLocation = res && res.length === 1 ? true : false;
      }
    });
  }

  getUserAccountData(userId): void {
    this.addToCart.getUserAccountDataFromDb(userId);
    this.userAccountSub = this.addToCart.userAccountData.subscribe(
      (userData) => {
        if (
          userData.res != null &&
          userData.res !== undefined &&
          userData.res?.length !== 0
        ) {
          this.usergetDataObj = userData.res.defaultB2BUnit;
          const accountId = this.usergetDataObj.uid;
          this.addToCart.getUserAccountDetailsDataFromDb(userId, accountId);
          this.userAccountDetailsSub =
            this.addToCart.userAccountDetails.subscribe((userDataget) => {
              if (userDataget) {
                this.getuserData = userDataget.res.shippingAddresses;
                this.searchedClientList = userDataget.res.shippingAddresses;





              }
            });
          this.cdr.detectChanges();
        }
      }
    );
  }
  getCartDetails(cartId): void {

    if (this.currentPage !== 'fluCategoryPage' &&
      this.currentPage !== 'fluStsLandingPage' &&
      this.currentPage !== 'FluverifypaymentPage' &&
      this.currentPage !== 'orderConfirmationFluPage' &&
      this.currentPage !== 'fluseasonreservationpage') {
      this.addToCart.getCarts(cartId, this.userAccountgetData?.uid);
      this.cartItemsSub = this.addToCart.cartItems$.subscribe((cartData: any) => {
        if (cartData) {
          this.cartDataMapping(cartData);
        }
      });
    }
  }

  navigatetoProduct(code) {
    this.route.go(`/product/${code}/${code}`, {
      queryParams: {
        variantSelected: true
      }
    });
  }
  cartDataMapping(data): void {
    this.productEntries = [];
    this.productFluEntries = [];
    this.cartId = data?.code;
    this.allCartDetails = [];
    this.allCartDetails = data?.childCarts;
    this.stdCartEntry = data.totalItems;

    if (this.allCartDetails) {
      this.stdCartDetails = this.allCartDetails;



      this.standardCartDetails = Object.assign({}, ...this.stdCartDetails);
      if (this.stdCartDetails.length <= 0) {
        this.isEmpty = true;
      } else if (this.stdCartDetails.length > 0) {
        this.isEmpty = false;
      }
      if (this.standardCartDetails?.shipToParty) {


        this.selectedData = this.standardCartDetails?.shipToParty;
      }

      this.orderSubTotal = 0;
      let totalUnitAll = 0;
      for (const cartDetails of this.stdCartDetails) {
        this.stdCartEntries = cartDetails;
        let tempEntries = [];

        if (!cartDetails?.hidePriceForProduct && !cartDetails?.hidePriceForTotals) {
          this.orderSubTotal += cartDetails?.subTotal?.value;
        } else {
          this.orderSubTotal = '$--'
        }
        this.cdr.detectChanges();
        for (let entries of cartDetails.entries) {

          const imagesFormat = _.clone(
            _.findWhere(entries.product?.images, { format: 'thumbnail' })
          );
          if (imagesFormat) {
            imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
          }
          this.images = { PRIMARY: imagesFormat };
          entries = { ...entries, ...this.images };
          tempEntries.push(entries);
          const quantity = [];
          for (const total of this.stdCartEntries?.entries) {
            quantity.push(total.quantity);
            this.totalquantityCart = quantity;
          }
          this.totalQuantity = this.totalquantityCart.reduce(
            (accumulator, currentValue) => accumulator + currentValue
          );






          if (!sessionStorage.getItem('sessionCartPopover')) {
            if (this.sessionCartPopover) {
              this.sessionCartPopover.open();
              setTimeout(() => this.sessionCartPopover.close(), 2500);
            }
            sessionStorage.setItem('sessionCartPopover', 'true');
          }
        }
        cartDetails['totalUnit'] = this.totalQuantity;
        totalUnitAll = totalUnitAll + Number(this.totalQuantity);
        cartDetails.entries = [...tempEntries];
        this.productEntries.push(cartDetails);
        this.cdr.detectChanges();
      }
      this.quantityDisplay = totalUnitAll > 99 ? '99+' : totalUnitAll;

      if (this.quantityDisplay === 0) {
        $('#cartNotificationPopup').hide();
        this.cdr.detectChanges();
      }
      this.fluCartDetails = this.allCartDetails.filter(
        (item) => item.cartType === 'INFLUENZA'
      );

      this.influenzaCartDetails = Object.assign({}, ...this.fluCartDetails);
      this.isEmptyFlu =
        this.influenzaCartDetails?.entries?.length <= 0 ||
          this.fluCartDetails?.length <= 0
          ? true
          : false;
      this.quantityDisplayFlu = '';
      for (const cartDetails of this.fluCartDetails) {
        this.fluCartEntries = cartDetails;
        for (let entries of cartDetails.entries) {
          const imagesFormat = _.clone(
            _.findWhere(entries.product?.images, { format: 'cartIcon' })
          );
          if (imagesFormat) {
            imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
          }
          this.images = { PRIMARY: imagesFormat };
          entries = { ...entries, ...this.images };
          this.productFluEntries.push(entries);
          const quantity = [];
          for (const total of this.fluCartEntries?.entries) {
            quantity.push(total.quantity);
            this.totalquantityfluCart = quantity;
          }
          this.totalQuantityFlu = this.totalquantityfluCart.reduce(
            (accumulator, currentValue) => accumulator + currentValue
          );
          if (this.totalQuantityFlu > 99) {
            this.quantityDisplayFlu = '99+';
          } else {
            this.quantityDisplayFlu = this.totalQuantityFlu;
          }
        }
        this.cdr.detectChanges();
      }
      this.saveCartName =
        this.productEntries.length >= 1
          ? this.productEntries[0]?.shipToLoc_name
          : '';
    }
    this.cdr.detectChanges();
  }
  toggleWithGreeting(popover) {
    this.cartEntryService.goToCart();





  }

  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = '';


  }
  navigateToPdp() {
    this.emptypopover.close();
    this.route.goByUrl('/Open-Catalogue/c/1');
  }
  saveOrder(): void {
    const reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    if (this.saveCartName && RegExp(reg).test(this.saveCartName)) {
      this.addToCart.saveCartDetails(this.saveCartName, this.cartId);
      this.invalidCartSub = this.addToCart.invalidCartName$.subscribe((res) => {
        if (res) {
          for (const error of res?.error?.errors) {
            this.errorMsg = error?.message;
          }
        }
      });
      this.saveCartSub = this.addToCart.saveCartSuccess$.subscribe((res) => {
        if (res) {
          this.stdpopover.close();
        }
      });
    } else {
      if (this.saveCartName) {
        this.errorMsg = 'Save cart name is not valid.';
      } else {
        this.errorMsg = 'The cart name cannot be blank.';
      }
    }
  }
  clearChildCart(): void {
    this.addToCart.clearCart(this.cartId, this.currentPage);
    if (localStorage.hasOwnProperty('futureshipModalOpened'))
      this.sharedService.removeLocalStorage('futureshipModalOpened');
  } // clear cart
  navigateToCart() {
    this.stdpopover.close();
    this.cartEntryService.goToCart();
  }

  navigateToSavedOrder() {
    this.emptypopover.close();
    this.route.goByUrl('/cart/save');
  }
  navigateTominiSavedOrder() {
    this.route.goByUrl('/cart/save');
  }
  navigateToFlu() {
    this.emptypopover.close();
    this.route.goByUrl('/influenza/dashboard');
  }
  navigateToNotification() {
    this.route.goByUrl('/messageHistoryPage');
  }
  navigateToFlufromCart() {
    this.flupopover.close();
    this.route.goByUrl('/influenza/cart');
  }
  naviToCartModal() {
    $('#cartNotificationPopup').hide();
    this.sharedService.miniCartPopup = false;
    this.cdr.detectChanges();
    this.cartEntryService.goToCart();
  }
  naviToPdpModal() {
    this.sharedService.miniCartPopup = false;
    $('#cartNotificationPopup').hide();
    this.cdr.detectChanges();
    this.route.goByUrl('/Open-Catalogue/c/1');
  }
  clearCartModal(): void {
    this.sharedService.miniCartPopup = false;
    $('#cartNotificationPopup').hide();
    this.cdr.detectChanges();
    this.addToCart.clearCart(this.cartId);
  }
  goToLogin() {
    this.route.goByUrl('/login');
  }

  goToNewOnboarding() {
    navigateToNewOnboarding(this.baseSiteId);
  }

  closepop() {
    if (this.stdpopover) {
      this.stdpopover.close();
    }
    if (this.emptypopover) {
      this.emptypopover.close();
    }
    if (this.flupopover) {
      this.flupopover.close();
    }
    this.errorMsg = '';


  }
  omit_special_char(event) {
    this.errorMsg = '';
    const reg = /^[^`!@#~$%\^&*()_+\-={};':"\\|[\]\\.,<>/\/?~]*$/;
    return new RegExp(reg).test(event.key);
  }
  ngOnDestroy() {
    this.updatedStdSub?.unsubscribe();
    this.plpMiniCartSub?.unsubscribe();
    this.pdpMiniCartSub?.unsubscribe();
    this.updateSessionSub?.unsubscribe();
    this.restoreSub?.unsubscribe();
    this.saveOrderSub?.unsubscribe();
    this.orderHistorySub?.unsubscribe();
    this.allCartItemsSub?.unsubscribe();
    this.userAccountSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.invalidCartSub?.unsubscribe();
    this.saveCartSub?.unsubscribe();
    this.userAccSub?.unsubscribe();
  }
  closePopup() {
    $('#cartNotificationPopup').hide();
    this.cdr.detectChanges();
  }
  stdFluDesc(productentry) {



    return productentry?.product?.description;
  }

  showLogin(): void {
    this.loginEntryService.openLogin(getLoginGateReturnUrl());
  }
}
